import React from "react";

export default function Terms() {
  return (
    <div className="pt-24 pb-24 max-w-3xl mx-auto px-4 md:px-8" data-testid="terms-page">
      <p className="text-xs font-bold tracking-[0.15em] uppercase text-[#A94438] mb-1">Legal</p>
      <h1 className="font-heading text-3xl md:text-5xl font-black tracking-tighter mb-6">Terms of Service</h1>
      <p className="text-xs text-[#5C5C54] mb-8">Last updated: {new Date().toLocaleDateString("en-GB", { year: "numeric", month: "long", day: "numeric" })}</p>

      <div className="prose prose-sm max-w-none text-[#3C3C38] space-y-6">
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">1. About AfriPantry</h2>
          <p>AfriPantry ("we", "us") operates a UK-based online marketplace connecting customers with independent vendors of African groceries. By using our website or placing an order, you ("the customer") agree to these Terms of Service.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">2. Marketplace Role</h2>
          <p>AfriPantry is a marketplace platform. Each product is sold and dispatched by an independent vendor. We facilitate discovery, ordering, payment collection and customer support, but the vendor is the seller of record for the items you receive.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">3. Account &amp; Eligibility</h2>
          <p>You must be 18 or older and resident in the United Kingdom to place an order. You are responsible for keeping your account credentials secure and for all activity that occurs under your account.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">4. Orders, Pricing &amp; Delivery</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>All prices are in GBP (£) and include VAT where applicable.</li>
            <li>A service fee of £1.50 is applied per cart to cover platform operations.</li>
            <li>Delivery fees are set per vendor and shown at checkout.</li>
            <li>Items from multiple vendors may arrive separately; each vendor dispatches independently.</li>
            <li>Estimated delivery times are best-effort and not guaranteed.</li>
          </ul>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">5. Payments</h2>
          <p>Payments are processed securely via Stripe. AfriPantry does not store your card details. If a payment fails, your order will not be dispatched.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">6. Cancellations &amp; Refunds</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>You can cancel a pending or accepted order from "My Orders" free of charge, up until the vendor starts preparing it.</li>
            <li>Perishable items (fresh produce, protein) are non-returnable once dispatched unless the product is defective or incorrect.</li>
            <li>Non-perishable items can be returned within 14 days of delivery in their original, unopened packaging in accordance with the UK Consumer Contracts Regulations 2013.</li>
            <li>Approved refunds are issued to your original payment method within 5–10 working days.</li>
          </ul>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">7. Product Information</h2>
          <p>Vendors are responsible for the accuracy of product descriptions, allergen information and ingredient labelling. If you have severe allergies, please contact the vendor via WhatsApp before ordering.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">8. Vendor Obligations</h2>
          <p>Vendors accepted onto the platform agree to fulfil orders promptly, describe products accurately, comply with UK food hygiene regulations (Food Standards Agency) and handle customer data responsibly.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">9. Prohibited Use</h2>
          <p>You may not use AfriPantry to resell bulk inventory, commit fraud, misuse promo codes, reverse-engineer the platform, or post unlawful content. We may suspend accounts at our discretion for abuse.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">10. Liability</h2>
          <p>To the extent permitted by UK law, AfriPantry's liability in connection with the marketplace is limited to the total amount you paid for the relevant order. We are not liable for losses that are not reasonably foreseeable.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">11. Changes to These Terms</h2>
          <p>We may update these Terms occasionally. Material changes will be communicated via email or a notice on this page. Continued use of the service after an update constitutes acceptance.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">12. Contact</h2>
          <p>Questions about these Terms? Reach us on WhatsApp at <a href="https://wa.me/447979127731" className="text-[#A94438] font-semibold">+44 7979 127731</a> or through the in-app support chat.</p>
        </section>
        <section>
          <h2 className="font-heading text-xl font-bold mb-2">13. Governing Law</h2>
          <p>These Terms are governed by the laws of England and Wales. Disputes are subject to the exclusive jurisdiction of the courts of England and Wales.</p>
        </section>
      </div>
    </div>
  );
}
